export const QuestionTypesMST: [
    "choice_picture_multiple",
    "choice_picture_single",
    "choice_text_multiple",
    "choice_text_single",
    "dummy",
    "input_table",
    "input_text",
    "input_unions_systems",
    "upload_handwriting"
] = [
    "choice_picture_multiple",
    "choice_picture_single",
    "choice_text_multiple",
    "choice_text_single",
    "dummy",
    "input_table",
    "input_text",
    "input_unions_systems",
    "upload_handwriting"
];

export enum QuestionTypes {
    choice_picture_multiple = "choice_picture_multiple",
    choice_picture_single = "choice_picture_single",
    choice_text_multiple = "choice_text_multiple",
    choice_text_single = "choice_text_single",
    dummy = "dummy",
    input_table = "input_table",
    input_text = "input_text",
    input_unions_systems = "input_unions_systems",
    upload_handwriting = "upload_handwriting"
}

export enum QuestionTypesRu {
    choice_picture_multiple = "Выбор нескольких вариантов-картинок",
    choice_picture_single = "Выбор одного варианта-картинки",
    choice_text_multiple = "Выбор нескольких текстовых/TeX вариантов",
    choice_text_single = "Выбор одного текстового/TeX варианта",
    dummy = "Задача-заглушка",
    input_table = "Множественный ввод TeX-текста",
    input_text = "Текстовый/TeX-ввод ответа",
    input_unions_systems = "Совокупности и системы TeX",
    upload_handwriting = "Загрузка рукописного решения в конце работы"
}

export const QuestionCategoriesMST: ["for_assignments", "for_test_exams"] = ["for_assignments", "for_test_exams"]

export enum QuestionCategories {
    for_assignments = "Для ДЗ/листков",
    for_test_exams = "Для пробных экзаменов"
}

// const CATEGORY_CUBE = 'Cube';
// const CATEGORY_DATABASE = 'Database';
// const CATEGORY_DATE_AND_TIME = 'Date and Time';
// const CATEGORY_ENGINEERING = 'Engineering';
// const CATEGORY_FINANCIAL = 'Financial';
// const CATEGORY_INFORMATION = 'Information';
// const CATEGORY_LOGICAL = 'Logical';
// const CATEGORY_LOOKUP_AND_REFERENCE = 'Lookup and Reference';
// const CATEGORY_MATH_AND_TRIG = 'Math and Trig';
// const CATEGORY_STATISTICAL = 'Statistical';
// const CATEGORY_TEXT_AND_DATA = 'Text and Data';